<div *ngIf="!isDealOver" fxLayoutGap="2px" [ngClass]="categoryId4 === 0 ? 'border' : 'noclass'">
  <div *ngIf="categoryId5==0" style="padding-bottom: 5px">
    <calsoft-common-header-carousel [products]="products" [other]="other" [type]="type" [item]="item" [header]="header"
      [id]="id"></calsoft-common-header-carousel>

  </div>
  <div *ngIf="categoryId5==1" style="padding-bottom: 5px">

  </div>

  <div *ngIf="categoryId5==2||categoryId5==3" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" class="commonHeader" fxLayout="row"
      fxLayoutAlign="space-between center">
      <span style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39}"
        [ngStyle.lt-md]="{'font-size': item.customField40}" [innerHTML]="header | uppercase"></span>

    </div>
  </div>

  <div *ngIf="categoryId5==4" style="padding-bottom: 5px">
    <div [style.background-color]="item.customField25" fxLayout="row" fxLayoutAlign="space-between center"
      fxLayoutAlign.xs="start start">

      <div fxLayout="row" fxLayout.xs="row" fxLayoutAlign="start center" fxLayoutAlign.xs="space-between center"
        fxFlex.xs="100" fxLayoutGap="20px">
        <div *ngIf="!hideTitle" style="font-weight: 500;" [ngStyle.gt-md]="{'font-size': item.customField39 }"
          [ngStyle.lt-md]="{
          'font-size': item.customField40}" [innerHTML]="header ">
        </div>

        <div *ngIf="showTimer">
          <div *ngIf="item.customField31 && !isDealOver" fxLayout="row" fxLayoutAlign="start center" style="gap: 8px;">
            <span>{{item.customField25}}</span>
            <mat-chip color="primary" selected class="countdown">
              {{ days }}d&nbsp;&nbsp;:&nbsp;&nbsp;{{ hours }}h&nbsp;&nbsp;:&nbsp;&nbsp;{{ minutes
              }}m&nbsp;&nbsp;:&nbsp;&nbsp;{{ seconds }}s
            </mat-chip>

          </div>
        </div>

      </div>


      <div style="cursor: pointer;" *ngIf="item.customField26" fxFlex fxLayout="row" fxLayoutAlign="end end"
        fxLayoutGap="7px" fxHide.lt-md>
        <h3 (click)="goToCategory()">{{item.customField26}}</h3>
        <mat-icon style="font-size: 22px;">arrow_forward</mat-icon>
      </div>

    </div>
  </div>

  <!-- Keep carousel in DOM to preserve layout/scroll. Show a non-blocking overlay loader until ready. -->
  <div *ngIf="products" class="background padingtb swiper-container" [swiper]="config" style="position:relative;">

    <!-- non-blocking overlay: pointer-events:none so it doesn't prevent scrolling on mobile -->
    <div *ngIf="!isReady" class="pc-overlay" aria-hidden="true">
      <div class="pc-loader">
        <mat-progress-spinner diameter="36" mode="indeterminate"></mat-progress-spinner>
      </div>
    </div>

    <div fxLayout="row wrap" class="swiper-wrapper h-100">
      <div *ngFor="let product of categoryProducts; let i = index; trackBy: trackByProduct" class="swiper-slide product-card">

        <calsoft-common-product-details-carousel [urlNavigation]="urlNavigation" [data]="data" [width]="width"
          [heightMobile]="heightMobile" [widthMobile]="widthMobile" [imageType]="imageType" [height]="height"
          [showConfigurableDropdown]="showConfigurableDropdown" [showCartIcon]="showCartIcon" [data]="data"
          [productLayoutEnable]="productLayoutEnable" [showCartIncremented]="showCartIncremented" [type]="'carousel'"
          [product]="product" [preload]="i < preloadCount"></calsoft-common-product-details-carousel>
      </div>
    </div>
    <button *ngIf="categoryId5!=4 && showArrows" fxShow fxHide.lt-md mat-mini-fab class="swiper-button-prev swipe-arrow">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button *ngIf="categoryId5!=4 && showArrows" mat-mini-fab fxShow fxHide.lt-md class="swiper-button-next swipe-arrow">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </div>

  <div *ngIf="categoryId5==3" fxLayout="row" fxLayoutAlign="center center"
    style="padding-top: 10px; padding-bottom: 10px;">
    <button class=" btn" (click)="goToCategory()">{{item.customField26}}</button>
  </div>
</div>